import React from "react";
import PropTypes from "prop-types";
import Paper from "@material-ui/core/Paper";
import withStyles from "components/with-styles";
import CenteredCardTitle from "./partial/centered-card-title";
import styles from "./styles/centered-card.css.js";

const CenteredCard = ({ classes, title, children }) => (
  <main className={classes.main}>
    <Paper elevation={2} className={classes.paper}>
      <div className={classes.divider_top} />
      <CenteredCardTitle>{title}</CenteredCardTitle>
      {children}
    </Paper>
  </main>
);

CenteredCard.propTypes = {
  /**
   ** Título de la tarjeta
   **/
  title: PropTypes.string,
};

export default withStyles(styles)(CenteredCard);
